import Phaser from 'phaser';
import { CafeScene } from './scenes/CafeScene';
import { AudioSystem } from './systems/AudioSystem';
import { SaveSystem } from './systems/SaveSystem';

export function createGame(parent: HTMLElement, audio: AudioSystem, save: SaveSystem, dayId = 1): Phaser.Game {
  return new Phaser.Game({
    type: Phaser.AUTO,
    parent,
    width: 1280,
    height: 720,
    backgroundColor: '#173f3a',
    antialias: true,
    render: {
      pixelArt: false,
      roundPixels: false,
    },
    scale: {
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width: 1280,
      height: 720,
    },
    scene: [new CafeScene(audio, save, dayId)],
    fps: {
      target: 60,
      forceSetTimeOut: false,
    },
  });
}
